import React from 'react'
import { Logo, NavLinks } from "../../components"

const Nav = () => {
  return (
    <nav className="desktopNav container">
        <Logo />
        <NavLinks />
    </nav>
  )
}

export default Nav